import CONFIG from "./config";
import log2 from "../js/log2-lite";

const log = log2("utils");
const isHighTrafficHostname = () => {
    const staticSites = ["www.vatanbilgisayar.com"];
    if (staticSites.includes(window.location.hostname)) {
        return true;
    } else if (window.location.hostname.includes("betnano")) {
        return true;
    }
    return false;
};

export const fetchSiteData = () => {
    log("fetching site data");
    const cachedData = localStorage.getItem("supsis-site-data");
    if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);
        if (Date.now() - timestamp < 24 * 60 * 60 * 1000) {
            // 1 gün
            log("using cached site data");
            return Promise.resolve(data);
        }
    }

    return fetch(`${CONFIG.TABLET_URL}sites/search/customer/${CONFIG.DOMAIN}`)
        .then((r) => {
            if (r.status === 200) {
                return r.json().then((json) => {
                    log("site data", json);
                    localStorage.setItem(
                        "supsis-site-data",
                        JSON.stringify({
                            data: json,
                            timestamp: Date.now(),
                        })
                    );
                    return json;
                });
            } else {
                return Promise.resolve(undefined);
            }
        })
        .catch((ex) => Promise.resolve(undefined));
};

export const fetchSiteSetting = (siteId) => {
    log("fetching site settings");
    if (isHighTrafficHostname()) {
        const cachedSettings = localStorage.getItem("supsis-settings");
        if (cachedSettings) {
            const { data, timestamp } = JSON.parse(cachedSettings);
            if (Date.now() - timestamp < 60 * 1000) {
                // 1 saat
                log("using cached site settings");
                return Promise.resolve(data);
            }
        }
    }

    return fetch(`${CONFIG.TABLET_URL}public/settings/get-all?contain=visibilityConfig,liveTraffic,liveAnalytics&lite=true`, {
        headers: {
            "site-id": siteId,
        },
    }).then((r) => {
        if (r.status === 200) {
            return r.json().then((settings) => {
                log("site settings fetched", settings);
                if (isHighTrafficHostname()) {
                    localStorage.setItem(
                        "supsis-settings",
                        JSON.stringify({
                            data: settings,
                            timestamp: Date.now(),
                        })
                    );
                }
                return settings;
            });
        } else {
            return undefined;
        }
    });
};

export const checkViewPort = function () {
    log("checkViewPort");
    let maybeMeta = document.querySelector("meta[name='viewport']");
    if (maybeMeta) {
        let content = maybeMeta.getAttribute("content");
        if (!content.includes("user-scalable=no")) {
            maybeMeta.setAttribute("content", content + ", user-scalable=no");
        } else {
            let meta = document.createElement("meta");
            meta.content = "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimal-ui";
            meta.name = "viewport";
            document.head.appendChild(meta);
        }
    }
};

export const onDocReady = () => {
    return new Promise((resolve, reject) => {
        if (document.readyState === "complete" || document.readyState === "interactive") {
            // call on next available tick
            setTimeout(resolve, 1);
        } else {
            document.addEventListener("DOMContentLoaded", resolve);
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./static/src/utils.js
// module id = null
// module chunks = 